import { useEffect, useMemo, useState } from 'react';

import { red } from '@mui/material/colors';

import { useIsClient } from '../utils/useIsClient';

import { notificationsComponents } from '.';

const emptyNotifications = notificationsComponents.map(() => false);

function initializeNotificationArrayFromStorage(localStorageNotifs: string) {
  const notifArrFromStorage: boolean[] = JSON.parse(localStorageNotifs);

  if (notificationsComponents.length > notifArrFromStorage.length) {
    notifArrFromStorage.unshift(
      ...Array.from(
        {
          length: notificationsComponents.length - notifArrFromStorage.length,
        },
        () => false,
      ),
    );
  } else if (notificationsComponents.length < notifArrFromStorage.length) {
    const popAmount = notifArrFromStorage.length - notificationsComponents.length;

    for (let i = 0; i < popAmount; i++) {
      notifArrFromStorage.pop();
    }
  }

  return notifArrFromStorage;
}

export const useNotifications = () => {
  const OLD_NOTIFICATION_KEY = 'notifications';
  const NOTIFICATION_KEY = '_NOTIFICATIONS';

  const [initialized, setInitialized] = useState<boolean>(false);
  const [notificationStatusArr, setNotificationStatusArr] = useState<boolean[]>(emptyNotifications);
  const [notifsRead, setNotifRead] = useState<boolean>(false);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState<number>(
    notificationsComponents.length,
  );
  const isClient = useIsClient();

  //initialzion
  useEffect(() => {
    const oldLocalStorage = window.localStorage.getItem(OLD_NOTIFICATION_KEY);
    const localStorage = window.localStorage.getItem(NOTIFICATION_KEY);

    if (!initialized) {
      setInitialized(true);

      if (oldLocalStorage) window.localStorage.removeItem(oldLocalStorage);

      if (!localStorage) {
        window.localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(emptyNotifications));
      } else {
        const notifArrFromStorage = initializeNotificationArrayFromStorage(localStorage);
        const unreadNotifications = notifArrFromStorage.filter((status: boolean) => status === false).length;

        setNotifRead(unreadNotifications === 0);
        setUnreadNotificationCount(unreadNotifications);
        setNotificationStatusArr(notifArrFromStorage);
      }
    }
  }, [isClient]);

  const setAllNotificationRead = () => {
    setNotificationStatusArr(oldArr => {
      const newNotifications = oldArr.map(val => {
        val = true;
        return val;
      });

      if (window) {
        window.localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(newNotifications));
      }

      return newNotifications;
    });

    setUnreadNotificationCount(0);
    setNotifRead(true);
  };

  const setNotificationRead = (index: number) => {
    setNotificationStatusArr(notifArr => {
      notifArr[index] = true;

      const unreadCount = notifArr.filter(status => status === false).length;

      if (window) {
        window.localStorage.setItem(NOTIFICATION_KEY, JSON.stringify(notifArr));
      }

      setNotifRead(unreadCount === 0);
      setUnreadNotificationCount(unreadCount);

      return notifArr;
    });
  };

  const notificationBubbleSx = useMemo(
    () =>
      isClient && !notifsRead
        ? {
            '&:after': {
              content: `"${unreadNotificationCount}"`,
              borderRadius: '50%',
              width: '16px',
              height: '16px',
              background: `${red['500']}A0`,
              lineHeight: '16px',
              position: 'absolute',
              top: '0px',
              right: '0px',
              fontSize: 12,
              fontWeight: 500,
              textAlign: 'center',
              zIndex: '10000',
            },
          }
        : {},
    [isClient, notifsRead, unreadNotificationCount],
  );

  return {
    setNotificationRead,
    setAllNotificationRead,
    notificationsRead: notifsRead,
    notificationBubbleSx,
    notificationsStatus: notificationStatusArr,
    notificationsComponents,
  };
};
